// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-modal .modal {
    border: thin solid var(--secondary-color-main);
    color: var(--secondary-color-dark);
    z-index: 2000;
}
.warning-modal svg.warning-modal__warning { 
    float: left;
    margin: 10px 10px;
    width: 96px;
    height: 96px;
    color: var(--secondary-color-main);
}
.warning-modal .modal .modal__close svg {
    color: var(--secondary-color-main);
}
.warning-modal__wrapper {
    padding: 20px;
}
.warning-modal .warning-modal__wrapper a:link,
.warning-modal .warning-modal__wrapper a:visited,
.warning-modal .warning-modal__wrapper a:active {
    color: var(--secondary-color-main);
}
.warning-modal .warning-modal__wrapper a:hover {
    color: var(--secondary-color-main-highlight);
}
`, "",{"version":3,"sources":["webpack://./client/components/errors/WarningModal.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,kCAAkC;IAClC,aAAa;AACjB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,aAAa;AACjB;AACA;;;IAGI,kCAAkC;AACtC;AACA;IACI,4CAA4C;AAChD","sourcesContent":[".warning-modal .modal {\n    border: thin solid var(--secondary-color-main);\n    color: var(--secondary-color-dark);\n    z-index: 2000;\n}\n.warning-modal svg.warning-modal__warning { \n    float: left;\n    margin: 10px 10px;\n    width: 96px;\n    height: 96px;\n    color: var(--secondary-color-main);\n}\n.warning-modal .modal .modal__close svg {\n    color: var(--secondary-color-main);\n}\n.warning-modal__wrapper {\n    padding: 20px;\n}\n.warning-modal .warning-modal__wrapper a:link,\n.warning-modal .warning-modal__wrapper a:visited,\n.warning-modal .warning-modal__wrapper a:active {\n    color: var(--secondary-color-main);\n}\n.warning-modal .warning-modal__wrapper a:hover {\n    color: var(--secondary-color-main-highlight);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
